export const parseErrorResponse = (errors) => {
  var _a, _b, _c;
  const oktaError = JSON.parse((_c = (_b = (_a = errors == null ? void 0 : errors.additional) == null ? void 0 : _a.res) == null ? void 0 : _b.text) != null ? _c : "{}");
  return oktaError == null ? void 0 : oktaError.message;
};
export const customizeUserPayload = (formData) => ({ ...formData, username: formData.email });
export default {
  parseErrorResponse,
  customizeUserPayload
};
